import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ConstructionBudgets } from '../../../pages/admin/constructions/ConstructionsDetails/budgets/ConstructionBudgets';
import { ConstructionDashboard } from '../../../pages/admin/constructions/ConstructionsDetails/dashboard/ConstructionDashboard';
import { ConstructionDocuments } from '../../../pages/admin/constructions/ConstructionsDetails/documents/ConstructionDocuments';
import { ConstructionPayable } from '../../../pages/admin/constructions/ConstructionsDetails/payables/ConstructionPayable';
import { ConstructionPhotos } from '../../../pages/admin/constructions/ConstructionsDetails/photos/ConstructionPhotos';
import { ConstructionTimeline } from '../../../pages/admin/constructions/ConstructionsDetails/timeline/ConstructionTimeline';
import { TabListStyled, TabStyled } from './index.styles';

export function Tab(props) {
  const { headingTab } = props;

  const navigate = useNavigate();
  const params = useParams();

  const { page } = params;

  const [selectedTab, setSelectedTab] = React.useState(page);

  const handleChange = (_event, newValue) => {
    navigate(`/constructions/${params.id}/${newValue}`);
  };

  useEffect(() => {
    setSelectedTab(page);
  }, [page]);

  return (
    <>
      <TabListStyled
        value={selectedTab}
        onChange={handleChange}
        variant="fullWidth"
      >
        {headingTab.map((heading) => (
          <TabStyled
            key={heading.title}
            value={heading.value}
            label={heading.title}
            icon={heading.icon}
            iconPosition="start"
          >
            <Typography>{heading?.icon}</Typography>
            <Typography style={{ fontSize: '14px' }}>
              {heading.title}
            </Typography>
          </TabStyled>
        ))}
      </TabListStyled>
      {selectedTab === 'payables' && <ConstructionPayable />}
      {selectedTab === 'budgets' && <ConstructionBudgets />}
      {selectedTab === 'schedules' && <ConstructionTimeline />}
      {selectedTab === 'photos' && <ConstructionPhotos />}
      {selectedTab === 'documents' && <ConstructionDocuments />}
      {selectedTab === 'dashboard' && <ConstructionDashboard />}
    </>
  );
}

Tab.propTypes = {
  headingTab: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
};
